import { utils, checkWin } from "@alife/cone-arms-core";
var bindEvent = utils.bindEvent;
// 记录滚屏次数
var scrollPageTimes = 0;
var startY = null;
var scrollTimer;
var handleDocumentScroll = function() {
    var scrollTopHeight = document.documentElement.scrollTop;
    if (!startY) {
        startY = scrollTopHeight;
        return;
    }
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function() {
        var height = document.documentElement.clientHeight;
        var endY = document.documentElement.scrollTop;
        var scrollHeight = startY ? Math.abs(endY - startY) : endY;
        if (scrollHeight > height / 4) scrollPageTimes += 1;
        startY = null;
    }, 200);
};
export var init = function() {
    var unbindScroll = function() {};
    if (checkWin()) unbindScroll = bindEvent(document, "scroll", handleDocumentScroll);
    return unbindScroll;
};
export var reset = function() {
    scrollPageTimes = 0;
};
export var getScrollPageTimes = function() {
    return scrollPageTimes;
};
